import { CerFormAdapter } from '@form/cer-form-adapter';

import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';

export class CurrencyForm extends CerFormAdapter {

  public override viewSetInit(viewSet: CerFormViewSet) {
    viewSet.viewAdd(this.getView());
  }

  private getView(): CerFormView {
    
    const view = new CerFormView();

    view.viewMetadata = {
      name: 'currency', dataApiName: 'Currency', text: 'Valutaer', textSingular: 'Valuta',
      primaryKey: 'num', titleFields: ['num', 'name'], baseFields: ['id', 'num', 'name'],
      allowCreate: false, allowEdit: false, allowDelete: false
    };

    return view;
  }
}
